import moment from 'moment';

import createReducer from 'reducers/createReducer';

import { Loader } from 'actions/actionTypes';

const INITIAL_STATE = {
    request: 0,
    response: 0,
    isPageLoad: false,

    error: {
        triggered: false,
        message: ''
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [Loader.CHANGE_LOADING_REQUEST]: (state, action) => {
        state.request = state.request + 1;
    },
    [Loader.CHANGE_LOADING_RESPONSE]: (state, action) => {
        state.response = state.response + 1;
    },
    [Loader.CHANGE_PAGE_LOAD]: (state, action) => {
        state.isPageLoad = action.payload;
    },
});

export default reducer;